export default "__VITE_ASSET__L0nnqqXl__"